// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__158pv","legacyBtn":"MutateMid_legacyBtn__2TX0e"};